<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
  <a (click)="goToRoute('saved-searches')" class="dropdown-item">My Saved Searches</a>
  <a (click)="goToRoute('other')" class="dropdown-item">Other</a>
</div>
